import type { GroupedPermission, PermissionGroup, PGroup } from '../../types/Permission';

export const groupPrivilegesByType = (group: PGroup[]): GroupedPermission =>
  group.reduce<GroupedPermission>((acc, current) => {
    if (current.privilege?.length) {
      const key = current.name !== 'Client' ? current.name : 'Company';
      acc[key as PermissionGroup] = current.privilege;
    }
    return acc;
  }, {});
